export enum Icons {
	Abstain = 'abstain',
	Alcohol = 'alcohol',
	Airplay = 'airplay',
	AlertCircle = 'alert-circle',
	AlertOctagon = 'alert-octagon',
	AlertTriangle = 'alert-triangle',
	Archive = 'archive',
	ArrowDown = 'arrow-down',
	ArrowDownCircle = 'arrow-down-circle',
	ArrowDownCircleColored = 'arrow-down-circle-colored',
	ArrowDownLeft = 'arrow-down-left',
	ArrowDownRight = 'arrow-down-right',
	ArrowLeft = 'arrow-left',
	ArrowLeftCircle = 'arrow-left-circle',
	ArrowLeftCircleColored = 'arrow-left-circle-colored',
	ArrowLeftCircleFilled = 'arrow-left-circle-filled',
	ArrowRight = 'arrow-right',
	ArrowRightCircle = 'arrow-right-circle',
	ArrowRightCircleColored = 'arrow-right-circle-colored',
	ArrowRightCircleFilled = 'arrow-right-circle-filled',
	ArrowUp = 'arrow-up',
	ArrowUpCircle = 'arrow-up-circle',
	ArrowUpCircleColored = 'arrow-up-circle-colored',
	ArrowUpLeft = 'arrow-up-left',
	ArrowUpRight = 'arrow-up-right',
	award = 'award',
	Asterisk = 'asterisk',
	Baby = 'baby',
	Bacteria = 'bacteria',
	Bacteria2 = 'bacteria-2',
	BarChart = 'bar-chart',
	BarChart2 = 'bar-chart-2',
	Bell = 'bell',
	BellOff = 'bell-off',
	Bike = 'bike',
	BMI = 'bmi',
	Book = 'book',
	BookOpen = 'book-open',
	Bookmark = 'bookmark',
	Boxers = 'boxers',
	Briefcase = 'briefcase',
	Calendar = 'calendar',
	Camera = 'camera',
	Cannabis = 'cannabis',
	Cast = 'cast',
	CardVisa = 'card-visa',
	CardDiscover = 'card-discover',
	CardMasterCard = 'card-mastercard',
	CardAmericanExpress = 'card-american-express',
	Chair = 'chair',
	Check = 'check',
	Check2 = 'check-2',
	CheckCircle = 'check-circle',
	CheckCircleLarge = 'check-circle-large',
	CheckCircleLargeColored = 'check-circle-large-colored',
	Chemicals = 'chemicals',
	ChevronDownCircleColored = 'chevron-down-circle-colored',
	ChevronDownSmall = 'chevron-down-small',
	ChevronLeftCircleColored = 'chevron-left-circle-colored',
	ChevronLeftSmall = 'chevron-left-small',
	ChevronRightCircleColored = 'chevron-right-circle-colored',
	ChevronRightSmall = 'chevron-right-small',
	ChevronUpCircleColored = 'chevron-up-circle-colored',
	ChevronUpDownSmall = 'chevron-up-down-small',
	ChevronUpSmall = 'chevron-up-small',
	Circle = 'circle-',
	Circle01Filled = '01-circle-filled',
	Circle02Filled = '02-circle-filled',
	Circle03Filled = '03-circle-filled',
	Circle04Filled = '04-circle-filled',
	Clipboard = 'clipboard',
	Clock = 'clock',
	CloudOff = 'cloud-off',
	Compass = 'compass',
	Concentration = 'concentration',
	Copy = 'copy',
	CreditCard = 'credit-card',
	CryogenicContainer = 'cryogenic-container',
	CryogenicVial = 'cryogenic-vial',
	Cup = 'cup',
	Database = 'database',
	Diet = 'diet',
	Dna = 'dna',
	Dog = 'dog',
	DollarSign = 'dollar-sign',
	Dot = 'dot',
	Doctor = 'doctor',
	Download = 'download',
	DownloadCloud = 'download-cloud',
	DownSperm = 'down-sperm',
	Drop = 'drop',
	Droplet = 'droplet',
	Edit = 'edit',
	Edit2 = 'edit-2',
	Edit3 = 'edit-3',
	ExternalLink = 'external-link',
	ExternalLink2 = 'external-link-2',
	Eye = 'eye',
	EyeOff = 'eye-off',
	Facebook = 'facebook',
	Feather = 'feather',
	File = 'file',
	FileMinus = 'file-minus',
	FilePlus = 'file-plus',
	FileText = 'file-text',
	Filter = 'filter',
	Fitness = 'fitness',
	Flag = 'flag',
	FlagTrans = 'flag-trans',
	Folder = 'folder',
	FolderMinus = 'folder-minus',
	FolderPlus = 'folder-plus',
	Freeze = 'Freeze',
	Frown = 'frown',
	Gift = 'gift',
	Globe = 'globe',
	Gmp = 'gmp',
	HardDrive = 'hard-drive',
	Headphones = 'headphones',
	Heart = 'heart',
	HeartPlus = 'heart-plus',
	HelpCircle = 'help-circle',
	HelpCircleFilled = 'help-circle-filled',
	Home = 'home',
	HotTub = 'hot-tub',
	Image = 'image',
	Inbox = 'inbox',
	Info = 'info',
	InfoBlue = 'info-blue',
	InsuranceShield = 'insurance-shield',
	Instagram = 'instagram',
	Interpunct = 'interpunct',
	Key = 'key',
	Kit = 'kit',
	LifeBuoy = 'life-buoy',
	Link = 'link',
	Link2 = 'link-2',
	Linkedin = 'linkedin',
	List = 'list',
	Loading = 'loading',
	Lock = 'lock',
	LogIn = 'log-in',
	LogOut = 'log-out',
	Mail = 'mail',
	Map = 'map',
	MapPin = 'map-pin',
	Maximize = 'maximize',
	Maximize2 = 'maximize-2',
	Meh = 'meh',
	Menu = 'menu',
	MessageCircle = 'message-circle',
	MessageSquare = 'message-square',
	Mic = 'mic',
	MicOff = 'mic-off',
	Minimize = 'minimize',
	Minimize2 = 'minimize-2',
	Minus = 'minus',
	MinusCircle = 'minus-circle',
	MinusSquare = 'minus-square',
	Monitor = 'monitor',
	Moon = 'moon',
	MoreHorizontal = 'more-horizontal',
	MoreVertical = 'more-vertical',
	Music = 'music',
	Navigation = 'navigation',
	Navigation2 = 'navigation-2',
	NoDiary = 'no-diary',
	NoGluten = 'no-gluten',
	NoPreservatives = 'no-preservatives',
	NoSugar = 'no-sugar',
	NonGmo = 'non-gmo',
	Note = 'note',
	Nsf = 'nsf',
	OpenModal = 'open-modal',
	Package = 'package',
	Package2 = 'package-2',
	Paperclip = 'paperclip',
	Percent = 'percent',
	Phone = 'phone',
	PhoneCall = 'phone-call',
	PhoneForward = 'phone-forward',
	PhoneIncoming = 'phone-incoming',
	PhoneMissed = 'phone-missed',
	PhoneOff = 'phone-off',
	PhoneOutgoing = 'phone-outgoing',
	PieChart = 'pie-chart',
	Pill = 'pill',
	Play = 'play',
	PlayVideo = 'play-video',
	Plus = 'plus',
	PlusCircle = 'plus-circle',
	PlusSquare = 'plus-square',
	Printer = 'printer',
	Rainbow = 'rainbow',
	Rectangle55 = 'Rectangle 55',
	RedMeat = 'red-meat',
	RefreshCcw = 'refresh-ccw',
	RefreshCw = 'refresh-cw',
	Search = 'search',
	Send = 'send',
	Server = 'server',
	Settings = 'settings',
	Share = 'share',
	Share2 = 'share-2',
	Shield = 'shield',
	ShieldOff = 'shield-off',
	ShoppingBag = 'shopping-bag',
	ShoppingCart = 'shopping-cart',
	Slash = 'slash',
	Sleep = 'sleep',
	Sliders = 'sliders',
	Smartphone = 'smartphone',
	Smile = 'smile',
	Smoking = 'smoking',
	Specialist = 'specialist',
	SpermNull = 'sperm-null',
	Spinner = 'spinner',
	Sperm = 'sperm',
	Sperm2 = 'sperm-2',
	SpermFilled = 'sperm-filled',
	SpermOutline = 'sperm-outline',
	Star = 'star',
	Syringe = 'syringe',
	Supplements = 'supplements',
	Swim = 'swim',
	Tablet = 'tablet',
	Tag = 'tag',
	ChevronDown = 'chevron-down',
	ChevronLeft = 'chevron-left',
	ChevronRight = 'chevron-right',
	ChevronUp = 'chevron-up',
	ThumbsDown = 'thumbs-down',
	ThumbsUp = 'thumbs-up',
	Tiktok = 'tiktok',
	Tool = 'tool',
	Trash = 'trash',
	Trash2 = 'trash-2',
	Truck = 'truck',
	Tv = 'tv',
	Twitter = 'twitter',
	Umbrella = 'umbrella',
	Unlock = 'unlock',
	Upload = 'upload',
	UploadCloud = 'upload-cloud',
	UpgradeAnalysis = 'upgrade-analysis',
	UsaMade = 'usa-made',
	User = 'user',
	UserCheck = 'user-check',
	UserCircle = 'user-circle',
	UserMinus = 'user-minus',
	UserPlus = 'user-plus',
	UserX = 'user-x',
	Users = 'users',
	Vascetomy = 'vascetomy',
	Veggie = 'veggie',
	Vial = 'vial',
	VialFilled = 'vial-filled',
	Video = 'video',
	VideoOff = 'video-off',
	Virus = 'virus',
	Voicemail = 'voicemail',
	Volume = 'volume',
	Volume1 = 'volume-1',
	Volume2 = 'volume-2',
	VolumeX = 'volume-x',
	Walk = 'walk',
	Watch = 'watch',
	Weight = 'weight',
	Wifi = 'wifi',
	WifiOff = 'wifi-off',
	X = 'x',
	XCircle = 'x-circle',
	XCircleColored = 'x-circle-colored',
	XOctagon = 'x-octagon',
	XSquare = 'x-square',
	Youtube = 'youtube',
	Zap = 'zap',
	ZapOff = 'zap-off',
	Zen = 'zen',
	ZoomIn = 'zoom-in',
	ZoomOut = 'zoom-out',
	IconMedical = 'icon-medical',
	IconPerson = 'icon-person',
	IconStroller = 'icon-stroller',
	IconWorker = 'icon-worker',
}

export type IconsType = typeof Icons
export type IconsPropType = Icons | `${Icons}` | '' | null | undefined
